module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAATCAYAAABGKffQAAAAAXNSR0IArs4c6QAAAVdJREFUOE+Vkr1KxEAUhc9N4s9upll0hQULcUHfQWwsrGy0UxMXVOz0HXwJOxVZSQoXLGQrCxtZ8B1EwULxB1fERCO6uTKTEFaZLHinG75zz7kzl/CPIsmya1+AqQo2J8h/fcnTJ7AjHgCUFWRSmepvzzpBAm9hAG1xC2AIBoAII9QInv4KFKwE27BwKR4BlGAR8B5XqBHedwsyWAkAgiNkhBL6CIi/R6n+IR1V/YIzF0e0laCfgM+vMfKjm1w4HVpmHk4FVfKja23nLoc7AJUkEiZ7wqnDFYDxnjGy7m5hCmS2EOcMmIErg9Ng6xwsDzdzY/CymIGBMwUCJ+QF8/qnc+1ZgE5T8Ii8YFGbmd3iHGA0VT/wIXlhTfsp7BQWYJjHchgwH5Afrmq/m117CQb56KiO++SF69pFYqe4BsvcQ4fl4++SH2zkr2hNcGKNHfKCTR0o734Az7t0hDhfn+UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img38.png
// module id = b07b
// module chunks = 1